export { default as defaultTemplate } from './defaultTemplate';
export { default as withAuth } from './withAuth';